import { Component, OnInit, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { FormControl, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Testata } from '../../../models/Testata';
import { BookService } from './../../../services/book.service';

import { map, startWith, switchMap, filter } from 'rxjs/operators';


@Component({
  selector: 'app-testata-autocomplete',
  templateUrl: './testata-autocomplete.component.html',
  styleUrls: ['./testata-autocomplete.component.css'],
  providers: [
    BookService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TestataAutocompleteComponent),
      multi: true
    }
  ]
})
export class TestataAutocompleteComponent implements OnInit {
  // items: Testata[];
  value: Testata;
  selected: string;
  error: boolean = false;
  loading: boolean;
  readonly: boolean = false;
  filteredOptions: Observable<string>;

  myControl = new FormControl('value', this.customValidator.bind(this));

  private customValidator(control: FormControl): void {

    if(!control.value ) {
     return null;
    } else {


      if (this.value && control.value != this.value.descrizione) {
        setTimeout(() => {
          control.setErrors({ myCustomError: true });
        })
      }
      if (!this.value && control.value) {
        setTimeout(() => {
          control.setErrors({ myCustomError: true });
        })
      }
    }

  }





  @Input() placeholder: string;
  @Input() required: boolean = false;
  @Output() notify: EventEmitter<Testata> = new EventEmitter<Testata>();

  constructor(private bookService: BookService) { }

  onChange(e) {
    console.log('onChange')
    this.value = e;
    console.log(e);
    this.notify.emit(e);
    this.propagateChange(e);
  }

  set _count(c: number) {
  }


  valuechange(newValue) {
    console.log(newValue)
  }


  search() {
    this.readonly = false;
  }

  click(event: any) {
    console.log('blur')
  }

  remove(event: any) {
    this.selected = ""
    this._empty()
  }

  _empty() {
    this.value = null;
    this.notify.emit(null);
    this.propagateChange(null);
  }

  check() {
    console.log('check',  this.selected)
    if(!this.selected) {
      this._empty()
    }
  }

  ngOnInit() {
    this.loading = true;
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        switchMap(value => this._filter(value))
      );
  }

  private _filter(value: any) {
    // console.log(value, Object.prototype.toString.call(value))

    const filterValue = (Object.prototype.toString.call(value) === '[object String]') ? value.toLowerCase() : value.descrizione;
    return this.bookService.readTestate().pipe(
      filter(data => !!data),
      map((data) => {
        // console.log(data)
        return data.items.filter(option => option.descrizione.toLowerCase().includes(value))
      })
    )


  }

  compareWithFn(o1: Testata, o2: Testata) {
    return o1 && o2 ? o1.codice == o2.codice : false;
  }

  private propagateChange = (_: any) => { };

  public writeValue(obj: Testata) {
    console.log(obj)
    this.value = obj;
    this.selected = obj ? obj.descrizione : '';
    // this.items.subscribe(a => {
    //   if (a) {
    //     if (obj) {
    //       this.selected = a.find(p => p.codice == obj.codice);
    //     }
    //     this.propagateChange(this.selected);
    //   }
    // })

  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }

}



// WEBPACK FOOTER //
// ./src/app/components/recensione/testata-autocomplete/testata-autocomplete.component.ts